import { ReactElement, useState } from 'react';
import { browser, device } from 'un-detector';
import { BrowserCompatibilityWarning } from '../components/BrowserCompatibilityWarning';

const isBrowserSupported = (): boolean => {
  return (browser.isEdge() || browser.isChrome() || browser.isFirefox()) && !device.isMobile();
};

export const BrowserCompatibilityContainer = (): ReactElement => {
  const [isOpen, setIsOpen] = useState(!isBrowserSupported());

  return (
    <>
      {isOpen && (
        <BrowserCompatibilityWarning
          onClose={(): void => {
            setIsOpen(false);
          }}
        />
      )}
    </>
  );
};
